import {Injectable} from '@angular/core';
import {IGraphData, IGraphNode, ILayerData, ITagretsNodes,  TGraphType} from '../models/graph-kn.model-interfaces';
import {GraphKnDataService} from './graph-kn.data.service';
import {CONTRACT_LAYER_ID} from '../models/graph-kn.cm-api-models';
import {MIN_ARROW_LENGTH} from '../models/graph-kn.cm.arrows-model-const';
import {GraphKnMoveStepRMService} from './graph-kn.move-steps-roadmap.service';

@Injectable({
    providedIn: 'root'
})
export class GraphKnNodeTargetsService {
	constructor(
		private knDataService: GraphKnDataService,
		private knMoveStepRMService: GraphKnMoveStepRMService,
	) {}

	generateTargetsNodes(graphData: IGraphData | undefined, topNodeYpos: number, layerData: ILayerData, layerId:TGraphType): ITagretsNodes[] {
        if (graphData === undefined) {
            return []
        }
        let layoutModel = layerId? this.knDataService.layoutDagreSettings.get(layerId)?.layoutModel : null;
        let layerWidth = layerData?.dimensions?.width;
        let targetsNodes: ITagretsNodes[] = []
        layerWidth = layerWidth || this.knDataService.graphStage.width()
        if (layoutModel == 'line') {
            this.knDataService.nodeCountPerStage = 1000
        } else {
            this.knDataService.nodeCountPerStage = Math.floor((layerWidth || this.knDataService.graphStage.width()) / (this.knDataService.nodeWidth + MIN_ARROW_LENGTH));
        }
        graphData.nodes.forEach((node:IGraphNode, index:number) => {
            let nodesPositinons = layerId === CONTRACT_LAYER_ID? this.knMoveStepRMService.calcNodePositions(index, node.position, layerData?.dragRect.attrs.id, topNodeYpos) :node.position
            targetsNodes.push({
                contractState: node.state || 'closed',
                node: node,
                state: node.state || 'none',
                x: nodesPositinons!.x!,
                y: nodesPositinons!.y!,
            });
			})
        layerId === CONTRACT_LAYER_ID ? targetsNodes = this.generateNodesStatus(targetsNodes) : null
        return targetsNodes
	}

	generateNodesStatus(targetsNodes: ITagretsNodes[]): ITagretsNodes[] {
        targetsNodes = targetsNodes.map(tg => {
            return tg = {
                ...tg,
                target_completed: !!tg.node.contract_step_data?.target?.verified_at == true,
                step_completed: !!tg.node.contract_step_data?.completed_at == true,
                active_step: false,
                target_errors: this.stepTargetErrors(tg)
            }
        })
        let active_step = targetsNodes.find(tg => tg.node.contract_step_data?.completed_at === null)
        targetsNodes[0].node.contract_step_data?.completed_at && active_step ? active_step.active_step = true : null;
        return targetsNodes
	}

	stepTargetErrors(target: ITagretsNodes): boolean {
        let step = target.node.contract_step_data
        switch (target.node.contract_step_data?.target_type) {
    /*             case 'multi_payment':
                        return !!(this.contractControlService.stepsElement[step.target_key] &&
                                this.contractControlService.stepsElement[step.target_key].isSignPaymentsALot);
                case 'credit_letter':
                        return step.target && (step.target.target_status === 'NO_MONEY' || step.target.target_status === 'SERVICE_NOT_AVAILABLE');
                case 'task':
                        if (this.contractControlService.currentMember) {
                                return this.contractControlService.copyContract?.contract.status === 'verified' &&
                                        !step.completed_at &&
                                        this.contractControlService.allSignatoriesInContract.length !== step.members_signed_step.length &&
                                        step.target && step.target.is_verified;
                        } else {
                                return false;
                        } */
                default:
                    return false;
        }
	}
}